import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../../config';
import { getImageUrl } from '../../utils/api';
import DashboardHeader from '../../components/dashboard/DashboardHeader';
import DashboardFooter from '../../components/dashboard/DashboardFooter';

const Page = styled.div`max-width: 900px; margin: 0 auto; padding: 24px 20px 60px;`;
const Card = styled.div`display: flex; gap: 16px; padding: 16px; border: 1px solid #eee; border-radius: 12px; margin-bottom: 16px; background: #fff;`;
const Cover = styled.div`width: 120px; height: 90px; border-radius: 8px; background-size: cover; background-position: center; background-color: #f0f0f0; flex-shrink: 0;`;

const MyPrograms = () => {
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    fetch(`${API_BASE_URL}/me/expert/my-programs`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => r.json())
      .then(d => setPrograms(d.data || []))
      .catch(() => setPrograms([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <DashboardHeader />
      <Page>
        <h1>Мои программы</h1>
        <p style={{ color: '#666', marginBottom: 24 }}>Купленные цифровые продукты экспертов</p>
        {loading && <p>Загрузка...</p>}
        {!loading && programs.length === 0 && (
          <p>У вас пока нет купленных программ. <Link to="/experts">Смотреть экспертов</Link></p>
        )}
        {programs.map(p => {
          const rawContent = p.content_data;
          const contentUrl = typeof rawContent === 'string'
            ? rawContent
            : (rawContent?.url || rawContent?.content_url || p.content_url || '');
          return (
          <Card key={p.id || p.digital_product_id}>
            <Cover style={{ backgroundImage: `url(${getImageUrl(p.cover_image)})` }} />
            <div>
              <h3 style={{ margin: '0 0 8px' }}>{p.title}</h3>
              {p.expert_name && <p style={{ margin: 0, fontSize: 14, color: '#888' }}>Эксперт: {p.expert_name}</p>}
              {contentUrl ? (
                <p style={{ marginTop: 8 }}>
                  <a href={contentUrl} target="_blank" rel="noreferrer">Открыть материалы</a>
                </p>
              ) : null}
              {p.expires_at && (
                <p style={{ fontSize: 13, color: '#666' }}>Доступ до: {new Date(p.expires_at).toLocaleDateString('ru-RU')}</p>
              )}
            </div>
          </Card>
          );
        })}
      </Page>
      <DashboardFooter />
    </>
  );
};

export default MyPrograms;
